export default __webpack_public_path__ + "static/media/Coverings of Purification.037fe35a.jpg";